import {combineReducers} from 'redux';
import * as actionType from '../actionType';
import handleAttachIdReducer from './handleAttachIdReducer';
import handleAttachWallIdentityReducer from './handleAttachWallIdentityReducer';
import cascadeAddressReducer from './taxpayer/cascadeAddressReducer';
import taxpayerInfoReducer from './taxpayer/registration/taxpayerInfoReducer';
import deliveryAddressReducer from './taxpayer/registration/deliveryAddressReducer';
import branchReducer from './taxpayer/registration/branchReducer';
import deviceReducer from './taxpayer/registration/deviceReducer';
import branchDeviceReducer from "./taxpayer/registration/branchDeviceReducer";
import selectDeviceReducer from './taxpayer/registration/selectDeviceReducer';
import mainBusinessReducer from './taxpayer/registration/mainBusinessReducer';
import secondaryBusinessReducer from './taxpayer/registration/secondaryBusinessReducer';
import deactivationBranchReducer from './taxpayer/deactivation/deactivationBranchReducer'
import deactivationDeviceReducer from './taxpayer/deactivation/deactivationDeviceReducer';
import reactivationBranchReducer from './taxpayer/reactivation/reactivationBranchReducer';
import reactivationDeviceReducer from './taxpayer/reactivation/reactivationDeviceReducer';
import deregistrationBranchReducer from './taxpayer/deregistration/deregistrationBranchReducer';
import deregistrationDeviceReducer from './taxpayer/deregistration/deregistrationDeviceReducer';
import taxpayerAddressNewReducer from './taxpayer/deactivation/taxpayerAddressNewReducer';
import menuRoutesReducer from './menuRoutesReducer';
import handleSearchFormDisplay from "./handleSearchFormDisplay";
import taxTypeListReducer from "./taxpayer/registration/taxTypeListReducer";
import disabledStateReducer from "./taxpayer/registration/disabledStateReducer";
import displayStateReducer from "./taxpayer/registration/displayStateReducer";
import branchDeviceBackUrlReducer from "./taxpayer/registration/branchDeviceBackUrlReducer";
import branchKeyReducer from "./taxpayer/registration/branchKeyReducer";
import taxpayerBranchDeviceStatus from "./taxpayer/amend/taxpayerBranchDeviceStatus";
import rejectedDataReducer from "./taxpayer/registration/rejectedDataReducer";
import handleSearchListReload from "./handleSearchListReload";
import handleMenuSearchListReload from "./handleMenuSearchListReload";
import upLoadLogo from './upLoadLogo'
import showMenu from './showMenu'
import initTaxpayerDetailByTin from './initTaxpayerDetailByTin'

function todos(state = [], action) {
  switch (action.type) {
    case actionType.ADD_TODO:
      return [
        ...state,
        {
          text: action.text,
          completed: false
        }
      ];
    case actionType.TOGGLE_TODO:
      return state.map((todo, index) => {
        if (index === action.index) {
          return Object.assign({}, todo, {
            completed: !todo.completed
          });
        }
        return todo;
      });
    default:
      return state;
  }
}

function switchLogo(state={},action){
  switch (action.type) {
    case actionType.SWITCH_LOGO:
      return action;
    default:
      return {type:"REFRESH_PAGE"};
  }
}

function visibilityFilter(state={} , action) {
  switch (action.type) {
    case actionType.SET_VISIBILITY_FILTER:
      return action.filter;
    default:
      return state;
  }
}
function refreshMenu(state ={},action){
  switch (action.type) {
    case actionType.REFRESH_MENU:
      return action;
    case actionType.LOGOUT:
      return action;
    default :
      return state;
  }
}
export default combineReducers({
  switchLogo,
  todos,
  refreshMenu,
  visibilityFilter,
  handleAttachIdReducer,
  handleAttachWallIdentityReducer,
  cascadeAddress:cascadeAddressReducer,
  taxpayer:taxpayerInfoReducer,
  deliveryAddress:deliveryAddressReducer,
  branchGridData:branchReducer,
  branchKey:branchKeyReducer,
  deviceGridData:deviceReducer,
  branchDeviceGridData:branchDeviceReducer,
  branchDeviceBackUrl:branchDeviceBackUrlReducer,
  taxTypeList:taxTypeListReducer,
  rejectedDataReducer:rejectedDataReducer,
  taxpayerBranchDeviceStatus:taxpayerBranchDeviceStatus,
  disabledStateManage:disabledStateReducer,
  displayStateManage:displayStateReducer,
  selectDeviceInfo:selectDeviceReducer,
  mainBusiness:mainBusinessReducer,
  secondaryBusiness:secondaryBusinessReducer,
  deactivationBranchGrid:deactivationBranchReducer,
  deactivationDeviceGrid:deactivationDeviceReducer,
  reactivationBranchGrid:reactivationBranchReducer,
  reactivationDeviceGrid:reactivationDeviceReducer,
  deregistrationBranchGrid:deregistrationBranchReducer,
  deregistrationDeviceGrid:deregistrationDeviceReducer,
  taxpayerAddressNew:taxpayerAddressNewReducer,
  menuData:menuRoutesReducer,
  handleSearchFormDisplay,
  handleSearchListReload,
  handleMenuSearchListReload,
  upLoadLogo:upLoadLogo,
  showMenu:showMenu,
  initTaxpayerDetailByTin:initTaxpayerDetailByTin
});
